module.exports = __webpack_public_path__ + "img/websiteDisplay.7e936270.webp";